// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"338":"b6746ab6","787":"83904489","843":"850ea2c1"}[chunkId] + ".chunk.js";
};